/* istanbul ignore file */

import { userManager } from 'config/oidc';
import { duckStatusLoading } from 'store/ducks/app';
import api from 'config/axios';
import { getEnvValue, getEnv } from 'config/enviroment';
import { interceptor } from 'config/interceptors';
import { duckTodosSistemas, duckUserProfile } from 'store/ducks/sefaz';
import { publicRoot, privateRoot, rotaAtendente } from 'routes/paths';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { IS_NEW_LOGIN, SISTEMAS_E_SEFAZ_USUARIO, USUARIO_LOGADO_FAS } from 'utils/consts';
import { fetchNotificationDebug } from 'store/fetchActions/fetchApp';
import jwt_decode from 'jwt-decode';

const env = getEnv();

export const getToken = () => {
  return sessionStorage.getItem(`oidc.user:${env.OIDC_AUTHORIY}:${env.OIDC_CLIENT}`);
};

export const fetchSignIn = () => {
  return userManager.signinRedirect();
};

export const getUser = () => {
  return JSON.parse(sessionStorage.getItem(`oidc.user:${env.OIDC_AUTHORIY}:${env.OIDC_CLIENT}`))?.profile || null;
};

export const getAndSaveUser = () => dispatch => {
  const userStorage = getUser();
  dispatch(duckUserProfile(userStorage));
  return userStorage;
};

export const fetchGetAllApps = listSystem => dispatch => {
  if (listSystem?.length > 0) return;
  dispatch(duckStatusLoading(true));
  api({
    url: `${getEnvValue('OIDC_AUTHORIY')}/api/sistemas/usuario`,
    method: 'GET',
  })
    .then(res => {
      dispatch(duckTodosSistemas(res?.data));
      localStorage.setItem(SISTEMAS_E_SEFAZ_USUARIO, JSON.stringify(res?.data));
    })
    .catch(erro => {
      interceptor(erro);
    })
    .finally(() => {
      dispatch(duckStatusLoading(false));
    });
};

export const signOut = (redirect = null, isNewLogin = false) => {
  sessionStorage.removeItem(USUARIO_LOGADO_FAS);
  if (isNewLogin) {
    localStorage.setItem(IS_NEW_LOGIN, true);
  }

  const authenticated = JSON.parse(getToken());
  const decodedToken = jwt_decode(authenticated?.access_token);

  if (Date.now() >= decodedToken.exp * 1000) {
    sessionStorage.clear();
    localStorage.clear();

    const rotaDirecionar = !isNewLogin ? publicRoot : privateRoot;
    if (redirect) redirect(rotaDirecionar);
    else window.location.pathname = rotaDirecionar;
    return true;
  }

  return userManager.signoutRedirect({
    id_token_hint: authenticated.id_token,
    post_logout_redirect_uri: userManager.settings.post_logout_redirect_uri,
  });
};

export const fetchUserSigninCallback = redirect => {
  return dispatch => {
    userManager
      .signinRedirectCallback()
      .then(response => {
        dispatch(duckUserProfile(response?.profile));

        if (response?.profile?.profile === ENUM_TIPO_PERFIL.ATENDENTE) redirect(rotaAtendente);
        else redirect(privateRoot);
      })
      .catch(function (error) {
        fetchNotificationDebug('fetchUserSigninCallback', error);
        localStorage.clear();
        sessionStorage.clear();
        return fetchSignIn();
      });
  };
};
